import { Observable } from 'rxjs';
import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '../../core/util/http.service';
import { NotificationService } from '../../core/util/notification.service';
var SiteSelectorService = (function () {
    function SiteSelectorService(dotHttpClient, notificationService) {
        this.dotHttpClient = dotHttpClient;
        this.notificationService = notificationService;
    }
    /**
     * Returns a list of sites searcing the hostname
     * @param searchQuery
     * @returns {Observable<R|T>}
     */
    SiteSelectorService.prototype.filterForSites = function (searchQuery) {
        var _this = this;
        return this.dotHttpClient.get('/api/v1/site?filter=' + searchQuery + '&archived=false')
            .map(function (res) { return _this.extractDataFilter(res); })
            .catch(function (err) { return _this.handleError(err); });
    };
    /**
     * Returns all sites
     * @returns {Observable<R|T>}
     */
    SiteSelectorService.prototype.getSites = function () {
        var _this = this;
        return this.dotHttpClient.get('/api/v1/site/')
            .map(function (res) { return _this.extractDataDropdown(res); })
            .catch(function (err) { return _this.handleError(err); });
    };
    SiteSelectorService.prototype.extractDataDropdown = function (res) {
        var obj = JSON.parse(res.text());
        if (obj.entity.sites && obj.entity.sites.results && obj.entity.sites.results.length > 0) {
            return obj.entity.sites.results;
        }
        return obj.entity;
    };
    SiteSelectorService.prototype.extractDataFilter = function (res) {
        var obj = JSON.parse(res.text());
        return obj.entity;
    };
    SiteSelectorService.prototype.handleError = function (error) {
        // we need use a remote logging infrastructure at some point
        var errMsg = (error.message) ? error.message :
            error.status ? error.status + " - " + error.statusText : 'Server error';
        if (errMsg) {
            console.log(errMsg);
            this.notificationService.displayErrorMessage('There was an error; please try again : ' + errMsg);
            return Observable.throw(errMsg);
        }
    };
    return SiteSelectorService;
}());
export { SiteSelectorService };
SiteSelectorService.decorators = [
    { type: Injectable },
    { type: Inject, args: ['dotHttpClient',] },
    { type: Inject, args: ['notificationService',] },
];
/** @nocollapse */
SiteSelectorService.ctorParameters = function () { return [
    { type: HttpClient, },
    { type: NotificationService, },
]; };
//# sourceMappingURL=site-selector.service.js.map